import { render, staticRenderFns } from "./PracticeSelection.vue?vue&type=template&id=502c3470&scoped=true&"
import script from "./PracticeSelection.vue?vue&type=script&lang=js&"
export * from "./PracticeSelection.vue?vue&type=script&lang=js&"
import style0 from "./PracticeSelection.vue?vue&type=style&index=0&id=502c3470&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "502c3470",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VContainer,VForm,VRow,VTextField})
